import UrlInputDialog from './UrlInputDialog';
import { reduxForm } from 'redux-form';
import validateTool from 'validate.js';

const validate = (data) => {
  return validateTool(data, {
      url: {
        presence: true
      }
    }) || {};
};

export default reduxForm(
  {
    form: 'rich_text_url_form',
    fields: ['url'],
    returnRejectedSubmitPromise: true,
    validate
  },
  undefined,
  (stateProps, dispatchProps) => ({
    initialValues: dispatchProps.data || {}
  })
)(UrlInputDialog);



// WEBPACK FOOTER //
// ./src/components/form/RichEditor/UrlInputDialog/index.js